/**
 * Generator 9: Create page — (authenticated)/<n>/new/page.tsx
 * Generates server page component for creating a new entity
 */

import type { GeneratedFile, GeneratorOptions, Schema } from '@core-engine/schema/types.js'
import { createGeneratedFile } from '@core-engine/utils/generated-files.js'
import {
  singularize,
  singularizeLabel,
  toKebabCase,
  toPascalCase
} from '@core-engine/utils/string.js'

// ============================================================================
// Public API
// ============================================================================

export interface CreatePageGeneratorResult {
  files: GeneratedFile[]
}

/**
 * Generate create page component for adding a new entity
 */
export function generateCreatePage(
  schema: Schema,
  pagesDir: string,
  _options: GeneratorOptions = {}
): CreatePageGeneratorResult {
  const singular = singularize(schema.name)
  const Singular = toPascalCase(singular)
  const singLabel = singularizeLabel(schema.label)
  const kebabName = toKebabCase(schema.name)

  const content = `import { ${Singular}Form } from '../${kebabName}-form'

export default function Create${Singular}Page() {
  return <${Singular}Form pageTitle="Create ${singLabel}" />
}
`

  return {
    files: [createGeneratedFile(`${pagesDir}/${schema.name}/new/page.tsx`, content)]
  }
}
